export enum CenterAlignedContentWidth {
  ExtraLarge = 1500,
  Large = 960,
  Medium = 720,
  Small = 320,
  Adaptive = '100%',
}

export enum CenterAlignedContentMargins {
  ExtraLarge = 0,
  Large = 40,
  Medium = 32,
  Small = 24,
}

export const BreakPoints = {
  ExtraLarge: 1365,
  Large: 1023,
  Medium: 767,
  Small: 766,
};

export const mediaQuery = (breakPoint: number | typeof BreakPoints): string =>
  `@media screen and (max-width: ${breakPoint}px)`;
